export default __webpack_public_path__ + "static/media/assessment-header.49189b02.jpg";